import { useState } from "react";

import { Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import CustomTextInput from "components/formComponents/CustomTextInput";
import CustomButton from "components/common/CustomButton";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import Axios from "services/api/config";
import { forgotPasswordURL } from "services/api/routes/Auth";

interface FormData {
	email: string;
}

const FPForm = () => {
	const navigate = useNavigate();
	const [state, setState] = useState({
		loading: false,
	});
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<FormData>();

	const onSubmit = async (data: FormData) => {
		try {
			setState((prev) => ({ ...prev, loading: true }));
			console.log(data);
			if (!data.email) return toast.error("Please Enter Email!");
			const { data: res }: any = await Axios({ ...forgotPasswordURL, data });
			navigate(`/verify-email`, {
				state: {
					email: data.email,
					requestId: res.data?.requestId,
					type: "forgot-password",
				},
			});
		} catch (error) {
			console.error(error);
		} finally {
			setState((prev) => ({ ...prev, loading: false }));
		}
	};

	return (
		<div className="md:w-1/2 flex justify-center items-center md:px-8 md:max-h-screen overflow-auto">
			<div className="p-8 flex flex-col justify-center items-center gap-4 text-black text-center">
				<div className="text-2xl md:text-4xl uppercase font-bold font-carmine">
					Reset Password!
				</div>
				<Typography className="text-lg mb-2 text-center text-wrap">
					Welcome Back! Please log in to access your dashboard and manage your
					store.
				</Typography>

				<form onSubmit={handleSubmit(onSubmit)} className="w-full">
					<div className="flex flex-col gap-4 w-full">
						{/* Company Name */}
						<Controller
							name="email"
							control={control}
							defaultValue=""
							// rules={{
							//   required: "Email is required",
							//   pattern: {
							//     value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
							//     message: "Invalid email address",
							//   },
							// }}
							render={({ field }) => (
								<CustomTextInput
									{...field}
									type="email"
									placeholder="Email"
									className="border-2 border-gray-400"
									autoFocus
									error={errors.email?.message}
								/>
							)}
						/>
						{/* Create Account Button */}
						<CustomButton
							title="Submit"
							type="submit"
							className="w-full"
							isLoading={state.loading}
							// isLoading={true}
						/>
					</div>
				</form>

				{/* Login Link */}
				{/* <p className="text-sm mt-2 text-center text-black">
					New User?{" "}
					<Link to="/register" className="text-primary font-semibold">
						Create Account
					</Link>
				</p> */}
			</div>
		</div>
	);
};

export default FPForm;
